var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36.5,
    r: 36.5,
    fill: "#ECF2FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.44 35.0499L37.25 44.2399C36.1241 45.3658 34.5972 45.9983 33.005 45.9983C31.4128 45.9983 29.8858 45.3658 28.76 44.2399C27.6341 43.1141 27.0016 41.5871 27.0016 39.9949C27.0016 38.4027 27.6341 36.8758 28.76 35.7499L37.95 26.5599C38.7005 25.8094 39.7185 25.3877 40.78 25.3877C41.8414 25.3877 42.8594 25.8094 43.61 26.5599C44.3605 27.3105 44.7822 28.3285 44.7822 29.3899C44.7822 30.4514 44.3605 31.4694 43.61 32.2199L34.41 41.4099C34.0347 41.7852 33.5257 41.996 32.995 41.996C32.4643 41.996 31.9553 41.7852 31.58 41.4099C31.2047 41.0346 30.9939 40.5256 30.9939 39.9949C30.9939 39.4642 31.2047 38.9552 31.58 38.5799L40.07 30.0999",
    stroke: "#808B9F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportIcon);
export default __webpack_public_path__ + "static/media/importIcon.7401b5e594cdf9481294f6426c645ae6.svg";
export { ForwardRef as ReactComponent };